<i [ngClass]="name" [style.background-color]="color"></i>
